import React, { useContext } from 'react'
import { HamburgerAnimation } from './HamburgerAnimation'
import { DefaultHeader } from './DefaultHeader'
import classNames from 'classnames'
import { SharedContext } from '../context/SharedContext'

export const ComponentsHeader = ({ backNavigation, title }) => {
  const { isMenuClicked, setMenuClicked, setScrollBar } = useContext(SharedContext)

  return (
    <div
      id="job_search_header"
      className={classNames(
        'sticky top-0 z-20 flex h-[44px] items-center justify-between bg-white pr-[12px]'
      )}
    >
      <DefaultHeader
        {...{
          title,
          backNavigation,
          isComponent: true
        }}
      />
      <div className="flex items-center border-[0px] border-l-xs border-solid border-l-[#E5E5E6]">
        <div
          id="header_burger_menu"
          className="flex h-fit w-fit cursor-pointer items-center pl-[10px]"
          onClick={() => {
            setMenuClicked(true)
            setScrollBar(false)
          }}
        >
          <HamburgerAnimation {...{ isClicked: isMenuClicked }} />
        </div>
      </div>
    </div>
  )
}
